var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowRight = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  style: {
    transform: "rotate(-180deg)"
  },
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.53 2.53a.75.75 0 0 0-1.06-1.06l-6 6a.748.748 0 0 0-.22.528v.004a.748.748 0 0 0 .22.528l6 6a.75.75 0 0 0 1.06-1.06L3.81 8.75H14a.75.75 0 0 0 0-1.5H3.81l4.72-4.72z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowRight);
export default ForwardRef;